<template>
  <flex-layout wrap>
    <base-input :model-value="props.lastName" class="col-6" placeholder="セイ（全角）"
                :rules="[rules.isKanaWithlabelName({name: 'セイ'}), rules.requiredWithLabelName({name: 'セイ'})]"
                required-tag @update:model-value="emit('update:lastName', $event)"/>
    <base-input :model-value="props.firstName" class="col-6" placeholder="メイ（全角）"
                :rules="[rules.isKanaWithlabelName({name: 'メイ'}),
                 rules.requiredWithLabelName({name: 'メイ'})]"
                required-tag @update:model-value="emit('update:firstName', $event)"/>
  </flex-layout>
</template>
<script setup lang="ts">
import {useValidator} from "@/composable/ui/useValidator";
import {defineEmits} from "vue";
import FlexLayout from "@/components/Layouts/FlexLayout.vue";
import BaseInput from "@/components/Forms/BaseInput.vue";

const props = defineProps({
  firstName: {
    type: String,
    required: true
  },
  lastName: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:firstName', 'update:lastName']);
const {rules} = useValidator();

</script>
<style scoped>
</style>
